import { Inject, Injectable } from "@angular/core";
import { OnuView } from "@nms-ng1/features/gpon-onus/gpon-onus-models";
import { GponOnuStatus } from "./gpon-onus.models";
import { DEVICE_DROPDOWN_MODEL_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Utilitário pra montagem dos dados das ONUs para exibição e aplicação
 * de template em um único passo.
 */
@Injectable({
    providedIn: "root"
})
export class GponOnusOneStepTemplateApplicationService {

    constructor(@Inject(DEVICE_DROPDOWN_MODEL_SERVICE) private readonly deviceDropdownModelService: any) { }

    /**
    * Retorna o valor da porta para a onu especificada removendo o prefixo gpon se ela existir,
    * caso contrário retorna null.
    */
    getPortValue(onu: OnuView) {
        if (onu.portViewName) {
            return onu.portViewName.split(" ").pop();
        }

        return null;
    }

    /**
    * Retorna o valor do serial number para a onu especificada se ele existir e o status da onu for "Descoberta",
    * caso contrário retorna null.
    */
    getSerialNumber(onu: OnuView) {
        if (onu.serialNumber && onu.status.toUpperCase() === GponOnuStatus.DISCOVERED) {
            return onu.serialNumber;
        }

        return null;
    }

    getOnusIds(onus: OnuView[]) {
        return onus.map((onu) => onu.onuId);
    }

    getSerialNumbers(onus: OnuView[]) {
        return onus.map(this.getSerialNumber);
    }

    isOnusSamePort(onus: OnuView[]) {
        const distinticPorts = new Set(onus.map((onu) => onu.portId));

        return distinticPorts.size === 1;
    }

    handleDataToSingleOnuApplication(deviceOnu: OnuView) {
        const templateVariables = [
            { name: "PORTA_PON", value: this.getPortValue(deviceOnu) },
            { name: "PORTA_GPON", value: this.getPortValue(deviceOnu) },
            { name: "ONU_ID", value: deviceOnu.onuId || null },
            { name: "NUMERO_SERIE_ONU_DESCOBERTA", value: this.getSerialNumber(deviceOnu) }
        ];

        const device = {
            id: deviceOnu.deviceId,
            name: deviceOnu.deviceName,
            hostname: deviceOnu.deviceHostname,
            model: deviceOnu.deviceModelName,
            availableFeatures: this.deviceDropdownModelService.getAvailableFeatures(deviceOnu.deviceId)
        }

        return {
            templateVariables,
            device
        }
    }

    handleDataToMultipleOnusApplication(deviceOnus: OnuView[]) {
        const deviceOnu = deviceOnus[0];

        const templateVariables = [
            { name: "PORTA_PON", value: this.getPortValue(deviceOnu) },
            { name: "PORTA_GPON", value: this.getPortValue(deviceOnu) },
            { name: "ONU_ID", value: this.getOnusIds(deviceOnus), fillVariableWithMultipleValues: true },
            {
                name: "NUMERO_SERIE_ONU_DESCOBERTA",
                value: this.getSerialNumbers(deviceOnus),
                fillVariableWithMultipleValues: true
            }
        ];

        const device = {
            id: deviceOnu.deviceId,
            name: deviceOnu.deviceName,
            hostname: deviceOnu.deviceHostname,
            model: deviceOnu.deviceModelName,
            availableFeatures: this.deviceDropdownModelService.getAvailableFeatures(deviceOnu.deviceId)
        }

        return {
            templateVariables,
            device
        }
    }
}
